"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTagDisplayStyles = void 0;
var themes_1 = require("../../../../themes");
var grey40 = themes_1.colors.grey40, green = themes_1.colors.green, yellow = themes_1.colors.yellow, blue = themes_1.colors.blue, error = themes_1.colors.error, purple = themes_1.colors.purple;
var getTagDisplayStyles = function (_a) {
    var colorPreset = _a.colorPreset;
    switch (colorPreset) {
        case "positive":
            return {
                backgroundColor: green,
            };
        case "inProgress":
            return {
                backgroundColor: blue,
            };
        case "warning":
            return {
                backgroundColor: yellow,
            };
        case "negative":
            return {
                backgroundColor: error,
            };
        case "special":
            return {
                backgroundColor: purple,
            };
        default:
            return {
                backgroundColor: grey40,
                backdropFilter: "blur(10px)",
            };
    }
};
exports.getTagDisplayStyles = getTagDisplayStyles;
